import React from "react";

//Images
import runningBond1 from "../../../images/variations/pattern-runningBond1.jpg";
import runningBond2 from "../../../images/variations/pattern-runningBond2.jpg";
import herringBone401 from "../../../images/variations/pattern-herringBone-40-1.jpg";
import herringBone402 from "../../../images/variations/pattern-herringBone-40-2.jpg";
import herringBone901 from "../../../images/variations/pattern-herringBone-90-1.jpg";
import herringBone902 from "../../../images/variations/pattern-herringBone-90-2.jpg";
import iPattern1 from "../../../images/variations/pattern-iPattern1.jpg";
import iPattern2 from "../../../images/variations/pattern-iPattern2.jpg";
import stackedBone1 from "../../../images/variations/pattern-stackedBone1.jpg";
import stackedBone2 from "../../../images/variations/pattern-stackedBone2.jpg";
import random1 from "../../../images/variations/pattern-random1.jpg";
import random2 from "../../../images/variations/pattern-random2.jpg";
import circle1 from "../../../images/variations/pattern-circle1.jpg";
import circle2 from "../../../images/variations/pattern-circle2.jpg";
import fan1 from "../../../images/variations/pattern-fan1.jpg";
import fan2 from "../../../images/variations/pattern-fan2.jpg";

const Patterns = () => {
  const patterns = [
    {
      title: <h4 className="mt-5">Running Bond</h4>,
      image1: runningBond1,
      image2: runningBond2,
    },
    {
      title: (
        <>
          <h4 className="mt-5">Herringbone</h4>
          <h4 className="mt-3">90 Degrees</h4>
        </>
      ),
      image1: herringBone901,
      image2: herringBone902,
    },
    {
      title: (
        <>
          <h4 className="mt-5">Herringbone</h4>
          <h4 className="mt-3">40 Degrees</h4>
        </>
      ),
      image1: herringBone401,
      image2: herringBone402,
    },
    {
      title: <h4 className="mt-5">Stacked Boned</h4>,
      image1: iPattern1,
      image2: iPattern2,
    },
    {
      title: <h4 className="mt-5">Running Bond</h4>,
      image1: stackedBone1,
      image2: stackedBone2,
    },
    {
      title: <h4 className="mt-5">Random Pattern</h4>,
      image1: random1,
      image2: random2,
    },
    {
      title: <h4 className="mt-5">Circle Pattern</h4>,
      image1: circle1,
      image2: circle2,
    },
    {
      title: <h4 className="mt-5">Fan Pattern</h4>,
      image1: fan1,
      image2: fan2,
    },
  ];

  const mapPatterns = () => {
    return patterns.map((pattern, index) => {
      return (
        <div className="row mt-4" key={index}>
          <div className="col-12 col-md-4 text-uppercase text-center">{pattern.title}</div>
          <div className="col-12 col-md-8">
            <div className="row">
              <div className="col-6 no-side-padding text-right">
                <img src={pattern.image1} alt="" />
              </div>
              <div className="col-6 no-side-padding">
                <img src={pattern.image2} alt="" />
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="row justify-content-center panel-patterns">
      <div className="col-12 text-uppercase text-center mt-5 mb-5">
        <h3 className="text-blue">
          Patterns
        </h3>
      </div>
      <div className="col-11 col-md-12 no-side-padding">
      {mapPatterns()}
      </div>
    </div>
  );
};

export default Patterns;
